import * as React from "react";
import {useState, useEffect} from "react";
import { jfetch } from "../../utils";
import { toast } from "../../utils";

function ToolsPage(props) {
  const [crystalAccess, setCrystalAccess] = useState(true)
  const [commissionAccess, setCommissionAccess] = useState(true)
  const [quoteAccess, setQuoteAccess] = useState(true)
  const [KPIAccess, setKPIAccess] = useState(true)
  const [videos, setVideos] = useState([])

  useEffect(() => {
    jfetch.get('/tools/access')
    .then((resp) => {
      resp.tools.forEach(tool => {
        if(tool.slug == 'commission_calc')
          setCommissionAccess(tool.access)
        if(tool.slug == 'crystal_ball')
          setCrystalAccess(tool.access)
        if(tool.slug == 'quote_calc')
          setQuoteAccess(tool.access)
        if(tool.slug == 'kpi_dashboard')
          setKPIAccess(tool.access)
      });
    })
    jfetch.get('/library/courses/demo')
    .then((resp) => {
      setVideos(resp.lessons_data)
    })
  }, [])

  function linkClicked(slug) {
    if(slug == '/crystal_ball/prospects' && !crystalAccess){
      toast.error('You do not have access to this tool')
      return
    }
    if(slug == '/commission_calculator' && !commissionAccess){
      toast.error('You do not have access to this tool')
      return
    }
    if(slug == '/quote_calculator' && !quoteAccess){
      toast.error('You do not have access to this tool')
      return
    }
    if(slug == '/kpi_dashboard' && !KPIAccess){
      toast.error('You do not have access to this tool')
      return
    }
    window.location.href = slug
  }

  return (
    <>
    <div className="tools-page" style={{maxWidth:'none', width:'auto'}}>
      <div style={{display:'flex', color:'black', flexWrap:'wrap', justifyContent:'center', paddingTop:'40px', paddingBottom:'40px'}}>
        <div className="icon-div" style={{cursor:'pointer', width:'26rem', backgroundColor:'white', textAlign:'center', margin:'20px', padding:'30px 18px', borderRadius:'20px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'}}>
          <a onClick={(e) => linkClicked("/crystal_ball/prospects")}>
            <div style={{}}>
              <i className={`fa-regular fa-star fa-2xl`} style={{padding:'20px', color:'white', backgroundColor:'#1368aa', borderRadius:'50%'}} />
            </div>
            <h2 style={{color:'black', fontSize:'22px'}}>
              Sales <br/> Crystal Ball {!crystalAccess && <i className="fa-solid fa-lock" style={{color:'red'}}/> }
            </h2>
          </a>
        </div>
        <div className="icon-div" style={{cursor:'pointer', width:'26rem', backgroundColor:'white', textAlign:'center', margin:'20px', padding:'30px 18px', borderRadius:'20px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'}}>
          <a onClick={(e) => linkClicked("/commission_calculator")}>
            <div style={{}}>
              <i className={`fa-solid fa-percent fa-2xl`} style={{padding:'20px', color:'white', backgroundColor:'#1368aa', borderRadius:'50%'}} />
            </div>
            <h2 style={{color:'black', fontSize:'22px'}}>
              Commission <br/> Calculator  {!commissionAccess && <i className="fa-solid fa-lock" style={{color:'red'}}/> }
            </h2>   
          </a>   
        </div>        
        <div className="icon-div" style={{cursor:'pointer', width:'26rem', backgroundColor:'white', textAlign:'center', margin:'20px', padding:'30px 18px', borderRadius:'20px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'}}>
          <a onClick={(e) => linkClicked("/quote_calculator")}>
            <div style={{}}>
              <i className={`fa-solid fa-file-invoice-dollar fa-2xl`} style={{padding:'20px', color:'white', backgroundColor:'#1368aa', borderRadius:'50%'}} />
            </div>
            <h2 style={{color:'black', fontSize:'22px'}}>
              Quote <br/> Calculator {!quoteAccess && <i className="fa-solid fa-lock" style={{color:'red'}} /> }
            </h2> 
            <p><small style={{color:'white', backgroundColor:'#1368aa', padding:'3px 5px', borderRadius:'3px'}}>Pending Quotes: {props.pendingQuotesCount}</small></p>
            {/* blue color: 0452c6  #1368aa */}
            {/* red color:  d0021b */}
          </a>
        </div>
        <div className="icon-div" style={{cursor:'pointer', width:'26rem', backgroundColor:'white', textAlign:'center', margin:'20px', padding:'30px 18px', borderRadius:'20px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'}}>
          <a onClick={(e) => linkClicked("/kpi_dashboard")}>
            <div style={{}}>
              <i className={`fa-solid fa-chart-line fa-2xl`} style={{padding:'20px', color:'white', backgroundColor:'#1368aa', borderRadius:'50%'}} />
            </div>
            <h2 style={{color:'black', fontSize:'22px'}}>
              KPI <br/> Dashboard {!KPIAccess && <i className="fa-solid fa-lock" style={{color:'red'}} /> }
            </h2> 
          </a>
        </div>        
      </div>
      {/* <!-- Nav tabs --> */}
      <ul className="nav nav-tabs" role="tablist">
        <li role="presentation" className="active">
          <a href="#crystal" aria-controls="crystal" role="tab" data-toggle="tab" style={{fontSize:'16px'}} >Crystal Ball</a>
        </li>
        <li role="presentation">
          <a href="#commission" aria-controls="commission" role="tab" data-toggle="tab" style={{fontSize:'16px'}}>Commission Calculator</a>
        </li>
        <li role="presentation">
          <a href="#quote" aria-controls="quote" role="tab" data-toggle="tab" style={{fontSize:'16px'}}>Quote Calculator</a>
        </li>
      </ul>

      {/* <!-- Tab panes --> */}
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active" id="crystal">
          { videos.slice(0,1).map( (video) => {
            return (
              <div key={video.id} style={{display:'flex', color:'black', flexWrap:'wrap', justifyContent:'center', paddingTop:'30px'}}>
                <div style={{cursor:'pointer', width:'75%', backgroundColor:'white', textAlign:'center', margin:'20px', padding:'30px 18px', borderRadius:'20px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'}}>
                  <h2>{video.title}</h2>
                  <p>{video.desc}</p>
                  {/* poster="https://images.pexels.com/photos/1229861/pexels-photo-1229861.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" */}
                  <video width="100%" controls src={video.aws_url} />
                </div>
              </div>
            )
          })}
        </div>
        <div role="tabpanel" className="tab-pane" id="commission">
          { videos.slice(1,2).map( (video) => {
            return (
              <div key={video.id} style={{display:'flex', color:'black', flexWrap:'wrap', justifyContent:'center', paddingTop:'30px'}}>
                <div style={{cursor:'pointer', width:'75%', backgroundColor:'white', textAlign:'center', margin:'20px', padding:'30px 18px', borderRadius:'20px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'}}>
                  <h2>{video.title}</h2>
                  <p>{video.desc}</p>
                  {/* poster="https://images.pexels.com/photos/1229861/pexels-photo-1229861.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" */}
                  <video width="100%" controls src={video.aws_url} />
                </div>
              </div>
            )
          })}          
        </div>
        <div role="tabpanel" className="tab-pane" id="quote">
          { videos.slice(2).map( (video) => {
            return (
              <div key={video.id} style={{display:'flex', color:'black', flexWrap:'wrap', justifyContent:'center', paddingTop:'30px'}}>
                <div style={{cursor:'pointer', width:'75%', backgroundColor:'white', textAlign:'center', margin:'20px', padding:'30px 18px', borderRadius:'20px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'}}>
                  <h2>{video.title}</h2>
                  <p>{video.desc}</p>
                  {/* poster="https://images.pexels.com/photos/1229861/pexels-photo-1229861.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" */}
                  <video width="100%" controls src={video.aws_url} />
                </div>
              </div>
            )
          })}             
        </div>
      </div>
    </div>
    </>
  );
}

export default ToolsPage;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/Tools.tsx